import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Play, Star, Truck, ShieldCheck, RotateCcw, Headphones, Activity, Zap, Sun, Moon, FlaskConical } from 'lucide-react';
import { getProductImageUrl } from '../../services/api';

const HeroBanner = () => {
  return (
    <section style={{ background: '#ffffff', color: '#0f172a', fontFamily: "'Plus Jakarta Sans', sans-serif", position: 'relative', overflow: 'hidden', paddingTop: '48px', paddingBottom: '40px' }}>
      
      {/* Generated White Background with Red Light Laser Beams & Waves Overlay */}
      <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.94) 25%, rgba(255, 255, 255, 0.65) 55%, rgba(255, 255, 255, 0.82) 100%), url('/hero_white_laser_bg_1787202417710.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        opacity: 0.95,
        pointerEvents: 'none',
        zIndex: 1
      }}></div>

      {/* Red Light Ambient Radial Glow on Right Side */}
      <div style={{ position: 'absolute', top: '10%', right: '5%', width: '600px', height: '600px', background: 'radial-gradient(circle, rgba(239, 68, 68, 0.22) 0%, rgba(220, 38, 38, 0.05) 50%, transparent 80%)', filter: 'blur(60px)', pointerEvents: 'none', zIndex: 1 }}></div>

      <div className="hero-banner-container" style={{ maxWidth: '1360px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
        
        {/* TOP HERO GRID: LEFT CONTENT + RIGHT PANEL RENDER */}
        <div className="hero-main-grid">
          
          {/* LEFT CONTENT COLUMN */}
          <div>
            {/* Top Pill Badge */}
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', border: '1px solid rgba(220, 38, 38, 0.3)', background: 'rgba(220, 38, 38, 0.06)', color: '#dc2626', fontSize: '11px', fontWeight: 800, letterSpacing: '0.12em', padding: '6px 16px', borderRadius: '9999px', textTransform: 'uppercase', marginBottom: '24px' }}>
              <span>CLINICALLY PROVEN TECHNOLOGY</span>
            </div>

            {/* Main Headline */}
            <h1 className="hero-title-responsive">
              Heal Smarter,<br />
              <span style={{ color: '#dc2626' }}>Live Better.</span>
            </h1>

            {/* Subhead */}
            <p style={{ fontSize: '16px', color: '#475569', lineHeight: 1.65, maxWidth: '480px', marginBottom: '32px', fontWeight: 500 }}>
              Advanced Red Light Therapy solutions designed to help you recover faster, feel better, and live your best life.
            </p>

            {/* 4 Circular Benefit Badges */}
            <div className="hero-benefits-grid" style={{ marginBottom: '36px' }}>
              
              {/* Badge 1 */}
              <div>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', border: '1px solid #fee2e2', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                  <Activity size={22} />
                </div>
                <h4 style={{ fontSize: '13px', fontWeight: 800, color: '#0f172a', margin: '0 0 4px 0' }}>Pain Relief</h4>
                <p style={{ fontSize: '11px', color: '#64748b', margin: 0, lineHeight: 1.4 }}>Reduces inflammation & joint pain</p>
              </div>

              {/* Badge 2 */}
              <div>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', border: '1px solid #fee2e2', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                  <Zap size={22} />
                </div>
                <h4 style={{ fontSize: '13px', fontWeight: 800, color: '#0f172a', margin: '0 0 4px 0' }}>Faster Recovery</h4>
                <p style={{ fontSize: '11px', color: '#64748b', margin: 0, lineHeight: 1.4 }}>Accelerates muscle repair & recovery</p>
              </div>

              {/* Badge 3 */}
              <div>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', border: '1px solid #fee2e2', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                  <Sun size={22} />
                </div>
                <h4 style={{ fontSize: '13px', fontWeight: 800, color: '#0f172a', margin: '0 0 4px 0' }}>Better Skin</h4>
                <p style={{ fontSize: '11px', color: '#64748b', margin: 0, lineHeight: 1.4 }}>Boosts collagen for healthier skin</p>
              </div>

              {/* Badge 4 */}
              <div>
                <div style={{ width: '48px', height: '48px', borderRadius: '50%', border: '1px solid #fee2e2', background: '#fef2f2', color: '#dc2626', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '10px' }}>
                  <Moon size={22} />
                </div>
                <h4 style={{ fontSize: '13px', fontWeight: 800, color: '#0f172a', margin: '0 0 4px 0' }}>Better Sleep & Mood</h4>
                <p style={{ fontSize: '11px', color: '#64748b', margin: 0, lineHeight: 1.4 }}>Supports deeper sleep & well-being</p>
              </div>

            </div>

            {/* CTA Buttons Row */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '32px' }}>
              <Link
                to="/shop"
                style={{
                  background: '#dc2626',
                  color: '#ffffff',
                  padding: '14px 28px',
                  borderRadius: '9999px',
                  fontSize: '14.5px',
                  fontWeight: 800,
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 10px 25px -5px rgba(220, 38, 38, 0.4)'
                }}
              >
                <span>Shop Panels</span>
                <ArrowRight size={17} />
              </Link>

              <Link
                to="/science"
                style={{
                  border: '1px solid #cbd5e1',
                  background: '#ffffff',
                  color: '#0f172a',
                  padding: '14px 28px',
                  borderRadius: '9999px',
                  fontSize: '14.5px',
                  fontWeight: 700,
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '8px',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.05)'
                }}
              >
                <span>Explore Science</span>
                <Play size={15} fill="#0f172a" color="#0f172a" />
              </Link>
            </div>

            {/* Social Proof Row */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ display: 'flex', marginLeft: '6px' }}>
              
              </div>

              
            </div>

          </div>

          {/* RIGHT CENTER-STAGE PANEL DISPLAY (LIFESTYLE RED LIGHT THERAPY SESSION PHOTO) */}
          <div style={{ position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            
            {/* Lifestyle Session Photo Card */}
            <div style={{ position: 'relative', width: '100%', maxWidth: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img
                src="/hero_person_red_light_session_1787202717236.jpg"
                alt="InfraEdge Red Light Therapy Session"
                style={{
                  width: '100%',
                  maxHeight: '480px',
                  objectFit: 'cover',
                  borderRadius: '24px',
                  border: '1px solid rgba(220, 38, 38, 0.2)',
                  boxShadow: '0 20px 45px -10px rgba(15, 23, 42, 0.15), 0 0 35px rgba(239, 68, 68, 0.25)',
                  display: 'block'
                }}
                onError={(e) => { e.target.src = getProductImageUrl('/uploads/panel_144led_pro.jpg'); }}
              />

              {/* Callout 1: 660nm Red Light */}
              <div style={{ position: 'absolute', top: '12%', right: '12px', maxWidth: '190px', background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(8px)', border: '1px solid #fee2e2', borderRadius: '12px', padding: '10px 12px', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)' }}>
                <h4 style={{ fontSize: '13px', fontWeight: 900, color: '#dc2626', margin: '0 0 3px 0' }}>660nm Red Light</h4>
                <p style={{ fontSize: '10.5px', color: '#475569', margin: 0, lineHeight: 1.35 }}>Visible red light to support skin health.</p>
              </div>

              {/* Callout 2: 850nm Near-Infrared */}
              <div style={{ position: 'absolute', top: '50%', right: '12px', maxWidth: '190px', background: 'rgba(255, 255, 255, 0.95)', backdropFilter: 'blur(8px)', border: '1px solid #fee2e2', borderRadius: '12px', padding: '10px 12px', boxShadow: '0 10px 25px -5px rgba(0,0,0,0.1)' }}>
                <h4 style={{ fontSize: '13px', fontWeight: 900, color: '#dc2626', margin: '0 0 3px 0' }}>850nm Near-Infrared</h4>
                <p style={{ fontSize: '10.5px', color: '#475569', margin: 0, lineHeight: 1.35 }}>Penetrates deeper for muscle recovery.</p>
              </div>

              {/* Circular Red Badge (Bottom Right): CLINICALLY PROVEN RESULTS */}
              <div style={{ position: 'absolute', bottom: '12px', left: '12px', width: '82px', height: '82px', borderRadius: '50%', border: '2px solid #dc2626', background: '#ffffff', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', textAlign: 'center', padding: '6px', boxShadow: '0 10px 25px -5px rgba(220, 38, 38, 0.25)' }}>
                <FlaskConical size={16} color="#dc2626" style={{ marginBottom: '2px' }} />
                <span style={{ fontSize: '7.5px', fontWeight: 900, letterSpacing: '0.06em', color: '#0f172a', lineHeight: 1.1 }}>CLINICALLY PROVEN</span>
              </div>
            </div>

          </div>

        </div>

        {/* BOTTOM VALUE PROPOSITION ROW (4 CARDS) */}
    
        {/* TRUST LOGOS BAR */}
        <div style={{ textAlign: 'center', paddingTop: '12px' }}>
          <span style={{ fontSize: '11px', fontWeight: 800, letterSpacing: '0.15em', color: '#64748b', textTransform: 'uppercase', display: 'block', marginBottom: '20px' }}>
            TRUSTED BY ATHLETES, WELLNESS EXPERTS & THOUSANDS OF CUSTOMERS
          </span>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '48px', flexWrap: 'wrap', opacity: 0.7, fontSize: '18px', fontWeight: 900, color: '#1e293b', fontFamily: 'serif', letterSpacing: '-0.02em' }}>
            <span>Men'sHealth</span>
            <span>Women'sHealth</span>
            <span>Forbes</span>
            <span>verywell health</span>
            <span>Healthline</span>
            <span>GQ</span>
          </div>
        </div>

      </div>
    </section>
  );
};

export default HeroBanner;